/** Keep in step with services/coms allowWorkAssignment.ts. */
export const OPERATIONS_SECTION_CHIEF_NAME = 'Operations Section Chief';

export const ALLOW_WORK_ASSIGNMENT_TOOLTIP =
  'When this is on, the position can receive work assignments such as an ICS-204. Operations Section Chief and every position under it start with this on. Every other position starts with it off.';

type SeatParent = {
  id: string;
  name: string;
  parent_id: string | null;
};

/**
 * A new seat defaults Allow Work Assignment on when it is the Operations
 * Section Chief, or when the seat it reports to is that chief or sits under
 * it.
 */
export function allowsWorkAssignmentByDefault(
  parentId: string | null | undefined,
  positions: SeatParent[],
  seatName?: string
): boolean {
  if (seatName?.trim() === OPERATIONS_SECTION_CHIEF_NAME) return true;
  if (!parentId) return false;

  const byId = new Map(positions.map((position) => [position.id, position]));
  const seen = new Set<string>();
  let current: string | null = parentId;

  while (current && !seen.has(current)) {
    seen.add(current);
    const seat = byId.get(current);
    if (!seat) return false;
    if (seat.name === OPERATIONS_SECTION_CHIEF_NAME) return true;
    current = seat.parent_id;
  }

  return false;
}
